/* eslint-disable no-unused-vars, no-underscore-dangle, react/prop-types */
import React, { useCallback, useMemo, useState } from "react";

import DataTableControlled from "src/Components/DataTableControlled";
import { getListingData } from "src/Components/DataTableControlled/utils";
import ActionColumn from "src/Components/DataTable/actionColumn";
import { PROCESSES_SERVICE } from "src/utils/Api";
import {
  DateFilter,
  SelectFilter,
  AsyncAutocompleteSelectFilter,
} from "src/Components/DataTable/filters";
import {
  getDateCell,
  mapValueFromOptions,
} from "src/Components/DataTable/commonCells";
import useOperators from "src/utils/hooks/operator/useOperators";
import DefaultTooltip from "src/Components/Tooltips/DefaultTooltip";
import __ from "src/utils/Translations";
import { getOperatorsOptionsFetchMethod } from "src/Components/FormElements/Autocomplete/commonFetchMethods";
import { useLocation } from "react-router-dom";

const statusOptions = [
  { value: "new", label: "Nowy" },
  { value: "in_progress", label: "W trakcie" },
  { value: "success", label: "Zakończony sukcesem" },
  { value: "warning", label: "Zakończony ostrzeżeniem" },
  { value: "failed", label: "Zakończony błędem" },
];

const serviceOptions = [
  { value: "employee", label: "Podstawowe dane pracownika" },
  { value: "subscriptions", label: "Dodatkowe dane pracownika" },
  { value: "tourism", label: "Obszary" },
  { value: "organization-structure", label: "Dodatkowe dane pracownika" },
];

const serviceFilterOptions = [
  { value: "employee", label: "Podstawowe dane pracownika" },
  {
    value: "subscriptions,organization-structure",
    label: "Dodatkowe dane pracownika",
  },
  { value: "tourism", label: "Obszary" },
];

export default function ImportsList({ companyId }) {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [createdByIds, setCreatedByIds] = useState([]);
  const location = useLocation();

  const baseUrl = location.pathname.split("/imports-history")[0];

  const showPath = `${baseUrl}/imports-history/show`;

  const fetchProcessList = useCallback(
    async (filters, page, pageSize, sort) => {
      const authors = [];
      const normalizedFilters = normalizeFilters(filters || []);

      console.log(filters, normalizedFilters);
      const { data: newData, count: newCount } = await getListingData(
        PROCESSES_SERVICE,
        "/ahr-processes",
        [...(normalizedFilters || []), { id: "companyId", value: companyId }],
        page,
        pageSize,
        sort || { key: "createdAt", value: "desc" },
        {
          dateFilters: ["createdAt", "updatedAt"],
        },
        []
      );

      newData.forEach(({ authorId }) => authorId && authors.push(authorId));
      setCreatedByIds([...new Set(authors)]);
      setData(newData);
      setCount(newCount);
    },
    [companyId]
  );

  const normalizeFilters = (filters = []) =>
    filters.map((filter) => {
      if (filter.id === "service") {
        return { id: filter.id, value: filter.value.split(",") };
      }
      return filter;
    });

  const AuthorFilter = useMemo(
    () =>
      AsyncAutocompleteSelectFilter(
        (filterValue) => getOperatorsOptionsFetchMethod(filterValue, 100),
        true,
        100
      ),
    []
  );

  const operators = useOperators(
    true,
    "id",
    createdByIds,
    false,
    !createdByIds.length
  );

  return (
    <>
      <DataTableControlled
        id="processedListing"
        service={PROCESSES_SERVICE}
        fetchData={fetchProcessList}
        data={data}
        count={count}
        filterable
        columns={[
          {
            Header: (
              <>
                {__("Nazwa importu")}{" "}
                <DefaultTooltip
                  id="tooltip-name"
                  content={<>{__("Nazwa importu + wykorzystany plik")}</>}
                />
              </>
            ),
            additionalHeader: true,
            accessor: "name",
            sortable: false,
          },
          {
            Header: (
              <>
                {__("Rodzaj")}{" "}
                <DefaultTooltip
                  id="tooltip-service"
                  content={<>{__("Rodzaj importu")}</>}
                />
              </>
            ),
            additionalHeader: true,
            accessor: "service",
            Filter: SelectFilter(serviceFilterOptions, true),
            Cell: mapValueFromOptions(serviceOptions, "service"),
            sortable: false,
          },

          {
            Header: (
              <>
                {__("Status")}{" "}
                <DefaultTooltip
                  id="tooltip-status"
                  content={
                    <>{__("Informacja o ostatecznym statusie importu")}</>
                  }
                />
              </>
            ),
            additionalHeader: true,
            accessor: "status",
            Cell: mapValueFromOptions(statusOptions, "status"),
            Filter: SelectFilter(statusOptions, true),
            sortable: false,
          },
          {
            Header: (
              <>
                {__("Przetworzone wiersze")}{" "}
                <DefaultTooltip
                  id="tooltip-currentStep"
                  content={<>{__("Aktualna liczba przetworzonych wierszy")}</>}
                />
              </>
            ),
            additionalHeader: true,
            accessor: "currentStep",
            filterable: false,
            sortable: false,
          },
          {
            Header: (
              <>
                {__("Ilość wierszy")}{" "}
                <DefaultTooltip
                  id="tooltip-maxStep"
                  content={
                    <>{__("Liczba wszytskich wierszy w użytym pliku")}</>
                  }
                />
              </>
            ),
            additionalHeader: true,
            accessor: "maxStep",
            filterable: false,
            sortable: false,
          },
          {
            Header: (
              <>
                {__("Zlecający")}{" "}
                <DefaultTooltip
                  id="tooltip-author"
                  content={<>{__("Użytkownik który uruchomił import")}</>}
                />
              </>
            ),
            additionalHeader: true,
            accessor: "authorId",
            Cell: mapValueFromOptions(operators, "authorId"),
            Filter: AuthorFilter,
            sortable: false,
          },
          {
            Header: "Rozpoczęto o",
            accessor: "createdAt",
            Filter: DateFilter(true),
            Cell: getDateCell("createdAt", true),
          },
          {
            Header: "Ostatnia aktualizacja",
            accessor: "updatedAt",
            Filter: DateFilter(true),
            Cell: getDateCell("updatedAt", true),
          },
          {
            Header: "Akcja",
            accessor: "action",
            filterable: false,
            sortable: false,
            maxWidth: 150,
            Cell: ({ row }) => (
              <div className="d-block w-100 text-center">
                <ActionColumn
                  data={row._original}
                  buttons={[
                    {
                      id: "showProcess",
                      href: `${showPath}/${row._original.uuid}?messageType[0]=warn&messageType[1]=error`,
                      className: "m-1",
                      color: "link",
                      label: "Podgląd",
                    },
                  ]}
                />
              </div>
            ),
          },
        ]}
      />
    </>
  );
}
